export default "__VITE_ASSET__CgugdDK5__"